import { t } from 'ember-intl';
import TioFooter from 'tio-common/components/tio/footer';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

<template>
  <div class="tio-col-flush h-screen container mx-auto overflow-auto">
    <div class="grow mx-auto mt-6 tio-bg-surface drop-shadow-md z-index-10 px-3">
      <div class="p-10">
        <div class="flex-col pr-16 pb-2">
          <p class="mb-3 font-normal"><b>{{t "auth.failed.title"}}</b></p>

          <p class="mb-5 tio-fg-disabled">{{t "auth.failed.instructions"}}</p>
        </div>
        <div class="text-center mt-3 -mb-3">
          <a class="tio-fg-info hover:tio-fg-info-h font-semibold" href="/login">
            {{t "auth.failed.sign_in_button"}}
          </a>
        </div>
      </div>
    </div>
    <div class="tio-row-flush justify-self-start h-full">
      {{svgJar "growth" role="img" desc=(t "svg.growth")}}
    </div>
    <TioFooter />
  </div>
</template>
